import {
    Box,
    FormControlLabel
} from '@mui/material';
import React, { useCallback } from 'react';
import { DynamicQuestionControl } from './DynamicQuestionControl';

export const DynamicQuestionMulti = ({
    question,
    truth,
    answer,
    disabled,
    onChange
}) => {
    const handleChange = useCallback((value) => {
        if (Array.isArray(answer)) {
            const index = answer.indexOf(value);
            if (index === -1) {
                onChange([...answer, value]);
            } else {
                const newTruth = [...answer];
                newTruth.splice(index, 1);
                onChange(newTruth);
            }
        } else {
            onChange([value]);
        }
    }, [onChange, answer]);

    return <div>
        <div className="fs-20 fw-semi-bold" style={{whiteSpace: 'pre-line'}}>{question.name}</div>
        <Box className="dynamic-question-content" display="flex" flexDirection="column">
            {question.options.map((option) => {
                const isTruth = Array.isArray(truth) && truth.includes(option.id);
                const isAnswer = Array.isArray(answer) && answer.includes(option.id);

                return <FormControlLabel
                    style={{alignItems: 'flex-start'}}
                    key={option.id}
                    value={option.id}
                    label={option.name}
                    control={<DynamicQuestionControl type="checkbox" isAnswer={isAnswer} isTruth={isTruth} disabled={disabled}/>}
                    checked={isTruth || isAnswer}
                    onChange={() => handleChange(option.id)}
                />;
            })}
        </Box>
    </div>;
};
